export default class Search {
  constructor() {
    this.searchIcon = document.querySelector('.menu__mobile__icon__search')
    this.searchIconImage = document.querySelector('.menu__mobile__icon__search__image')
    this.searchForm = document.querySelector('.search-form')

    this.searchFlag = true

    this.click()
  }

  click() {
    this.searchIcon.addEventListener('click', () => {
      this.open()
    })
  }

  open() {
    this.searchIcon.classList.add('menu__mobile__icon__search__opened')
    this.searchIconImage.style.display = 'none'
    this.searchForm.style.display = 'flex'
  }
}
